import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
	//mode: 'history', //用history去除地址栏#号 ，默认是hash模式
	routes: [{
			path: '/',
			redirect: '/index'
		},
		{
			path: '/',
			component: resolve => require(['@/views/main.vue'], resolve),
			meta: {
				title: '首页'
			},
			children: [{
					path: '/index',
					name: 'index',
					component: resolve => require(['@/views/index.vue'], resolve),
					meta: {
						title: '首页'
					}
				},
				{
					path: '/ss_user',
					name: 'ss_user',
					component: resolve => require(['@/views/SystemSet/UserPower/ss_user.vue'], resolve),
					meta: {
						title: '用户权限'
					}
				},

				{
					path: '/unit',
					name: 'unit',
					component: resolve => require(['@/views/Unit/unit.vue'],
						resolve),
					meta: {
						title: '用户开通注册'
					}
				},
				{
					path: '/unit_member',
					name: 'unit_member',
					component: resolve => require(['@/views/UnitMember/unit_member.vue'],
						resolve),
					meta: {
						title: '会员商户管理'
					}
				},

				{
					path: '/system_parameter',
					name: 'system_parameter',
					component: resolve => require([
						'@/views/SystemSet/SystemParam/system_parameter.vue'
					], resolve),
					meta: {
						title: '系统参数设置'
					}
				},
				{
					path: '/user_operation_log',
					name: 'user_operation_log',
					component: resolve => require(['@/views/SystemSet/Log/user_operation_log.vue'],
						resolve),
					meta: {
						title: '操作日志'
					}
				},
				{
					path: '/mes_version',
					name: 'mes_version',
					component: resolve => require(['@/views/Version/mes_version.vue'],
						resolve),
					meta: {
						title: '版本管理'
					}
				},
				{
					path: '/mes_version_edit',
					name: 'mes_version_edit',
					component: resolve => require(['@/views/Version/mes_version_edit.vue'],
						resolve),
					meta: {
						title: '版本编辑'
					}
				},
				{
					path: '/service_rotation_img',
					name: 'service_rotation_img',
					component: resolve => require(['@/views/Market/service_rotation_img'],
						resolve),
					meta: {
						title: '电视轮播图'
					}
				},{
					path: '/extend',
					name: 'extend',
					component: resolve => require(['@/views/Extend/extend'],
						resolve),
					meta: {
						title: '其它扩展功能'
					}
				},{
					path: '/unit_extend',
					name: 'unit_extend',
					component: resolve => require(['@/views/Unit/unit_extend'],
						resolve),
					meta: {
						title: '扩展功能地址'
					}
				}

				, {
					path: '/bath_document',
					name: 'bath_document',
					component: resolve => require(['@/views/BathDocument/bath_document'],
						resolve),
					meta: {
						title: '消费记录'
					}
				}
			]
		},
		{
			path: '/login',
			name: 'login',
			component: resolve => require(['@/views/Login.vue'], resolve)
		},
		{
			path: '/mes_version_detail',
			name: 'mes_version_detail',
			component: resolve => require(['@/views/Version/mes_version_detail.vue'], resolve),
			meta: {
				title: '升级日志'
			}
		},
		{
			path: '*',
			redirect: '/404'
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js